export enum HorariosDisponiveisTypes {
  'LOAD_REQUEST' = '@horariosDisponiveis/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@horariosDisponiveis/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@horariosDisponiveis/LOAD_FAILURE',

  'CLEAN_HORARIOSDISPONIVEIS' = '@horariosDisponiveis/CLEAN_HORARIOSDISPONIVEIS',
}

export interface HorariosDisponiveis {
  dhAgendamento: string;
  prevConclusao: string;
  qtdPlat: number;
}

export interface HorariosDisponiveisState {
  readonly data: HorariosDisponiveis[] | undefined;
  readonly loading: boolean;
  readonly error: boolean;
}
